import React from 'react';
import { BarChart3, Mail, Phone, MapPin, Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';

const SocialLink: React.FC<{ href: string; icon: React.ReactNode }> = ({ href, icon }) => (
  <a 
    href={href}
    className="bg-gray-800 p-2.5 rounded-full hover:bg-primary-600 transition-all duration-300 hover:scale-110"
    target="_blank"
    rel="noopener noreferrer"
  >
    {icon}
  </a>
);

const Footer: React.FC = () => {
  return (
    <footer className="bg-black text-white pt-20 pb-10">
      <div className="container">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-16 mb-16">
          <div>
            <div className="flex items-center space-x-3 mb-8">
              <div className="bg-white/10 p-2 rounded-xl">
                <BarChart3 size={32} className="text-primary-400" />
              </div>
              <span className="font-sans text-2xl font-bold tracking-tight">Wealth Wave</span>
            </div>
            <p className="text-gray-400 mb-8 text-lg">
              We transform your demat accounts into powerful profit-generating assets with our expert-led, data-driven strategies.
            </p>
            <div className="flex space-x-3">
              <SocialLink href="#" icon={
                <Facebook size={20} />
              } />
              <SocialLink href="#" icon={
                <Twitter size={20} />
              } />
              <SocialLink href="#" icon={
                <Instagram size={20} />
              } />
              <SocialLink href="#" icon={
                <Linkedin size={20} />
              } />
            </div>
          </div>
          
          <div>
            <h3 className="font-sans text-lg font-semibold mb-6 text-white/90">Quick Links</h3>
            <ul className="space-y-4">
              <li>
                <a href="#services" className="text-gray-400 hover:text-white transition-colors hover:translate-x-1 inline-block">Services</a>
              </li>
              <li>
                <a href="#about" className="text-gray-400 hover:text-white transition-colors hover:translate-x-1 inline-block">About Us</a>
              </li>
              <li>
                <a href="#testimonials" className="text-gray-400 hover:text-white transition-colors hover:translate-x-1 inline-block">Testimonials</a>
              </li>
              <li>
                <a href="#team" className="text-gray-400 hover:text-white transition-colors hover:translate-x-1 inline-block">Our Team</a>
              </li>
              <li>
                <a href="#contact" className="text-gray-400 hover:text-white transition-colors hover:translate-x-1 inline-block">Contact</a>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-sans text-lg font-semibold mb-6 text-white/90">Services</h3>
            <ul className="space-y-4">
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors hover:translate-x-1 inline-block">Demat Account Management</a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors hover:translate-x-1 inline-block">Portfolio Optimization</a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors hover:translate-x-1 inline-block">Tax-Efficient Investing</a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors hover:translate-x-1 inline-block">Wealth Advisory</a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors hover:translate-x-1 inline-block">Market Analysis</a>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-sans text-lg font-semibold mb-6 text-white/90">Contact Us</h3>
            <ul className="space-y-6">
              <li className="flex items-start space-x-4">
                <div className="bg-primary-900/50 p-2 rounded-lg">
                  <MapPin size={20} className="text-primary-400" />
                </div>
                <span className="text-gray-400">1234 Financial District, Mumbai, Maharashtra 400001, India</span>
              </li>
              <li className="flex items-center space-x-4">
                <div className="bg-primary-900/50 p-2 rounded-lg">
                  <Phone size={20} className="text-primary-400" />
                </div>
                <a href="tel:+919876543210" className="text-gray-400 hover:text-white transition-colors hover:translate-x-1">
                  +91 9876 543 210
                </a>
              </li>
              <li className="flex items-center space-x-4">
                <div className="bg-primary-900/50 p-2 rounded-lg">
                  <Mail size={20} className="text-primary-400" />
                </div>
                <a href="mailto:info@wealthwave.com" className="text-gray-400 hover:text-white transition-colors hover:translate-x-1">
                  info@wealthwave.com
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 mb-4 md:mb-0">
              &copy; {new Date().getFullYear()} Wealth Wave. All rights reserved.
            </p>
            <div className="flex space-x-8">
              <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm hover:translate-x-1 inline-block">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm hover:translate-x-1 inline-block">
                Terms of Service
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm hover:translate-x-1 inline-block">
                Disclaimer
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;